// eslint-disable-next-line import/prefer-default-export
export const data = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <h4>Proceso de Inicio de Sesión en el Portal para Padres EngagED (Interno/Externo)</h4>,
    Interrupt_p0: (
        <h5>
            Para iniciar sesión,{" "}
            <strong>
                <u>NO</u>
            </strong>{" "}
            usará su correo electrónico personal.
        </h5>
    ),
    Interrupt_p1: (
        <>
            Para iniciar sesión, deberá ingresar una dirección de correo electrónico compuesta por su{" "}
            <strong>
                <u>nombre de usuario</u>
            </strong>{" "}
            seguido de{" "}
            <strong>
                <u>@p.dcsdk12.org</u>
            </strong>{" "}
            en la pantalla de inicio de sesión que aparece a continuación.
            <br />
            Por ejemplo: si su <b>nombre de usuario</b> es <b>jsmith</b>, ingresará{" "}
            <strong>
                <u>jsmith@p.dcsdk12.org</u>
            </strong>
            .
            <br />
            <br />
            Su contraseña es la misma que usa para acceder a Infinite Campus (padre actual) o la contraseña que creó
            durante la configuración de la cuenta para la Inscripción Abierta (padre externo).
        </>
    ),
    Interrupt_p2: (
        <strong>
            Si necesita ayuda con su nombre de usuario o contraseña, por favor, vaya a{" "}
            <a href="https://password.dcsdk12.org" rel="noreferrer" target="_blank">
                password.dcsdk12.org
            </a>
            .
        </strong>
    ),
    Interrupt_p3: (
        <>
            <b>Si no puede acceder después de seguir los pasos anteriores, por favor, contáctenos:</b>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Soporte Técnico para Padres - Inglés
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Soporte Técnico para Padres - Español
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Soporte Técnico para Padres - Chino
            </a>
            <br />
            Centro de Soporte de TI: <b>303.387.0001</b>
        </>
    ),
    Interrupt_note:
        "NOTA: Los empleados del distrito que son padres actuales deben seguir las instrucciones anteriores utilizando una ventana de navegador de incógnito o privada y/o un navegador diferente.",
    Interrupt_submit: "Proceder a iniciar sesión",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Bienvenido,",
    Main_Nav_HelpfulLinks: "Enlaces útiles",
    Main_Nav_LogOut: "CERRAR SESIÓN",
    Main_Nav_HelpfulLinks_LI_s1: "Contactar a la enfermera de mi(s) estudiante(s)",
    Main_Nav_HelpfulLinks_LI_s2: "Calendarios Académicos",
    Main_Nav_HelpfulLinks_LI_s3: "Recursos para Padres",
    Main_Nav_HelpfulLinks_LI_s4: "Rutas de Autobús",
    Main_Nav_HelpfulLinks_LI_s5: "Pagos en Línea",
    Main_Nav_HelpfulLinks_LI_s6: "Menús de Almuerzo",
    Main_Nav_Exit: "SALIR",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_BackToDashboard: "Volver al Tablero",
    Global_Dashboard: "Tablero",
    Global_Faq: "Preguntas Frecuentes",
    Global_Close: "Cerrar",
    Global_Completed: "Completado",
    Global_Currently_Unavailable: "Actualmente no disponible",
    Global_InProgress: "En Progreso",
    Global_GoTo: "Ir A",
    Global_Loading: "Por favor espere mientras recopilamos la información de su estudiante...",
    Global_MoreInfo: "Más Información",
    Global_NotStarted: "No Iniciado",
    Global_Open: "Abrir",
    Global_Status: "Estado",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "Tablero del Tutor de DCSD",
    Breadcrumb_Back: "Portal para Padres EngagED de DCSD",
    Breadcrumb_EPR: "Boletas de Calificaciones Archivadas de DCSD",
    Breadcrumb_Translations: "Las traducciones son experimentales",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Report Card /////////////////////////////
    /// /////////////////////////////////////////////////////////
    EPR_Available: "La Boleta de Calificaciones de su estudiante estará disponible el", // [some variable date string]
    EPR_Failure1: "Lo sentimos, no podemos recuperar el PDF de la Boleta de Calificaciones para el estudiante",
    EPR_Failure2: "Por favor proporcione la siguiente información al contactar al distrito para soporte:",
    EPR_No_Data: "No se encontraron Boletas de Calificaciones históricas para el estudiante.",
    EPR_Not_Found:
        "La Boleta de Calificaciones de su estudiante aún no está lista. Por favor, comuníquese con la escuela de su estudiante para obtener más información.",
    EPR_Success: "PDF de la Boleta de Calificaciones recuperado exitosamente para el estudiante.",
    EPR_Title: "Recursos de Boletas de Calificaciones Archivadas",
    EPR_View_Archive: "Boletas de Calificaciones Archivadas",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Most Recent /////////////////////////
    /// /////////////////////////////////////////////////////////
    Most_Recent_Title: "Boleta de Calificaciones Más Reciente",
    Most_Recent_Pdf_Download: "Descargar PDF",
    Most_Recent_Success: "PDF de la Boleta de Calificaciones recuperado exitosamente para el estudiante.",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Student Info ////////////////////////
    /// /////////////////////////////////////////////////////////
    Student_Info_Address: "Dirección",
    Student_Info_Grade: "Grado",
    Student_Info_School: "Escuela",
    Student_Info_School_Year: "Año Escolar",
    Student_Info_Teacher: "Maestro/a",
    Student_Info_Not_Ready: (
        <>
            El PDF de la Boleta de Calificaciones no está listo.
            <br />
            Por favor, vuelva a consultar pronto.
        </>
    ),
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Student Select //////////////////////
    /// /////////////////////////////////////////////////////////
    Student_Select_Instructions: "Seleccione un estudiante para ver su Boleta de Calificaciones",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// About ///////////////////////////////
    /// /////////////////////////////////////////////////////////
    About_Epr: "Acerca de la Boleta de Calificaciones",
    About_Based:
        "La Boleta de Calificaciones se basa en el Currículo Garantizado y Viable (GVC) del Distrito Escolar del Condado de Douglas. Todos los elementos se califican en la siguiente escala:",
    About_Exceeds: "Supero las expectativas de los estándares y puedo cumplirlos de forma independiente y precisa.",
    About_Meets:
        "Cumplo las expectativas de los estándares y puedo realizarlos de forma independiente sin errores importantes.",
    About_Approaching: "Demuestro una comprensión parcial de los estándares y/o necesito apoyo para realizarlos.",
    About_Does_Not_Meet: "No cumplo las expectativas de los estándares y/o necesito un apoyo considerable.",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Semester ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Semester_Semester: "Semestre",
    Semester_Selected: "Semestre Seleccionado",
    Semester_Overall: "Comentarios Generales",
    Semester_Comment_All: "Comentario para Todos los Estudiantes",
    Semester_Comment_Student: "Comentario del Semestre",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Resources ///////////////////////////
    /// /////////////////////////////////////////////////////////
    Resources_Associated: "Recursos Asociados",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// SLE /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Sle_Title: "Expectativas a Nivel Escolar",
    Sle_Comment: "Comentario de Expectativas a Nivel Escolar",
    Sle_Comment_To_All: "Comentario sobre las Expectativas de Nivel Escolar para Todos los Estudiantes",
    Sle_No_Ratings: "No se ingresaron calificaciones",
    Sle_No_Comment: "No se ingresó ningún comentario",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Subject /////////////////////////////
    /// /////////////////////////////////////////////////////////
    Subject_Selected: "Materia Seleccionada",
    Subject_Comments: "Comentarios",
    Subject_Comment: "Comentario",
    Subject_To_All: "Comentario para Todos los Estudiantes para",
    Subject_Ratings: "Calificaciones",
    Subject_Accelerated: "Avanzado",
    Subject_Evidence_Outcome: "Resultado de Evidencia",
    Subject_Evidence_Outcome_Child: "Resultados de Evidencia del Niño",
    Subject_Standard: "Estándar",
    Subject_Student_Comment: "Comentario del Estudiante",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Summary /////////////////////////////
    /// /////////////////////////////////////////////////////////
    Summary_Title: "Resumen",
    Summary_Comment: "Comentario",
    Summary_To_All: "Comentario para Todos los Estudiantes",
    Summary_Ratings: "Calificaciones",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Teacher /////////////////////////////
    /// /////////////////////////////////////////////////////////
    Teacher_Title: "Maestro/a",
    Teacher_Comment: "Comentario",
    Teacher_To_All: "Comentario para Todos los Estudiantes",
    Teacher_Ratings: "Calificaciones",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Archived ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Archived_Description: "Ver o descargar las Boletas de Calificaciones Archivadas de su estudiante",
    Archived_Resources: "Recursos de Boletas de Calificaciones Archivadas",
    Archived_Fail_1:
        "Lo sentimos, no podemos recuperar el PDF de la Boleta de Calificaciones para el estudiante para el año escolar",
    Archived_Fail_2: (
        <>
            Por favor proporcione la siguiente información al contactar al distrito para soporte:
            <br />
        </>
    ),
    Archived_Success:
        "PDF de la Boleta de Calificaciones recuperado y descargado exitosamente para el estudiante para el año escolar",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// 404 /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Page_Not_Found: "Página No Encontrada",
    Page_Not_Found_Message:
        "Esta aplicación no está disponible según la URL que ingresó O su posición actual O su ubicación actual."
};
